module.exports = __webpack_public_path__ + "img/angle-3.c8c0a87f.png";